export const UPSERT_ENGINEER = "UPSERT_ENGINEER"
export const UPSERT_ENGINEER_SUCCESS = "UPSERT_ENGINEER_SUCCESS"
export const UPSERT_ENGINEER_FAIL = "UPSERT_ENGINEER_FAIL"

export const GET_LIST_ENGINEER = "GET_LIST_ENGINEER"
export const GET_LIST_ENGINEER_SUCCESS = "GET_LIST_ENGINEER_SUCCESS"
export const GET_LIST_ENGINEER_FAIL = "GET_LIST_ENGINEER_FAIL"

export const POST_ENGINEER_PAYMENT_CUSTOM = "POST_ENGINEER_PAYMENT_CUSTOM"
export const POST_ENGINEER_PAYMENT_CUSTOM_SUCCESS = "POST_ENGINEER_PAYMENT_CUSTOM_SUCCESS"
export const POST_ENGINEER_PAYMENT_CUSTOM_FAIL = "POST_ENGINEER_PAYMENT_CUSTOM_FAIL"

export const UPSERT_ENG_HISTORY = "UPSERT_ENG_HISTORY"
export const UPSERT_ENG_HISTORY_SUCCESS = "UPSERT_ENG_HISTORY_SUCCESS"
export const UPSERT_ENG_HISTORY_FAIL = "UPSERT_ENG_HISTORY_FAIL"

export const FILTER_ENGINEER = "FILTER_ENGINEER"
export const FILTER_LOADING = "FILTER_LOADING"


export const RESET_ENGINEER_FLAG = "RESET_ENGINEER_FLAG"
export const GET_ENG_LEAVES = "GET_ENG_LEAVES"
export const GET_ENG_LEAVES_SUCCESS = "GET_ENG_LEAVES_SUCCESS"
export const GET_ENG_LEAVES_FAIL = "GET_ENG_LEAVES_FAIL"

export const UPSERT_ENG_LEAVE = "UPSERT_ENG_LEAVE"
export const UPSERT_ENG_LEAVE_SUCCESS = "UPSERT_ENG_LEAVE_SUCCESS"
export const UPSERT_ENG_LEAVE_FAIL = "UPSERT_ENG_LEAVE_FAIL"

export const DELETE_ENG_LEAVE = "DELETE_ENG_LEAVE"
export const DELETE_ENG_LEAVE_SUCCESS = "DELETE_ENG_LEAVE_SUCCESS"
export const DELETE_ENG_LEAVE_FAIL = "DELETE_ENG_LEAVE_FAIL"